import { IKioskModel } from "models/kioskModel";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import loading from "../../../../images/loading.gif";

const PageLoading: React.FC = () => {
  const loadings = useSelector(
    (state: any) => (state.kioskReducer as IKioskModel).loading
  );
  const { t } = useTranslation("translations");
  const language = useSelector((state: any) => {
    if (state?.kioskReducer?.language)
      return (state.kioskReducer as IKioskModel).language;
    else return "";
  });

  return (
    <>
      {" "}
      <div className="pageLoad">
        {loadings && (
          <div className="d-flex flex-column align-items-center processing_msg">
            {/* <span>{t("Kiosk.fetchMes" + language)}</span> */}
            <img src={loading} alt="loading" width="200" />
          </div>
        )}
      </div>
    </>
  );
};

export default React.memo(PageLoading);
